import React from 'react';
import { Form, Button, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { Lock } from '../../assets/icons';
import AuthInfo from '../AuthInfo/AuthInfo';
import AuthForm from '../AuthForm/AuthForm';
import OTPInput from '../OTPInput';
import './PinPage.scss'

const PinPage = (props) => {
  const {
    setPin,
    handleSubmit,
    pin,
    authInfoTitle,
    authInfoDescription,
    authFormTitle,
    authFormDescription,
    linkLoading = false,
    loading,
    buttonName,
    linkName,
    linkReDirection,
    backButton,
    backButtonRedirection,
    lockMessage,
    onLinkClick,
    attemptCount,
    countDown,
    seconds,
    disabledCheckbox
  } = props;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return (
    <>
      <AuthInfo
        title={<>{authInfoTitle}</>}
        description={<>{authInfoDescription}</>}
        note={
          lockMessage && <>
            <Lock marginRight='10px' />
            <span className='fw-400'>{lockMessage}</span>
          </>
        }
      />
      <AuthForm
        title={<>{authFormTitle}</>}
        description={<>{authFormDescription}</>}
      >
        <Form className='auth-form pin-form login-pin'>
          <OTPInput
            length={4}
            otp={pin}
            onClearOtp={pin}
            onChangeOTP={(otp) => setPin(otp)}
            className='otp otp--start mb-48'
            autoFocus
            disabled={loading || linkLoading || disabledCheckbox}
            inputClassName='otp__input'
          />
          {countDown > 0 && <div className='mb-10 fw-500'>You can retry after {countDown} seconds</div>}
          {seconds < 300 && seconds > 0 && (
            <div className='mb-10 fw-500'>
              You can retry after {minutes > 0 && `${minutes} minutes `}
              {remainingSeconds < 60
                ? `${remainingSeconds} seconds`
                : `${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds} seconds`}
            </div>
          )}
          <Link disabled={linkLoading} onClick={onLinkClick} to={linkReDirection && `/${linkReDirection}`} className='underline text-terracotta fw-600 mr-8'>
            {linkName}
            <Spin className='ml-20' spinning={linkLoading} />
          </Link>
          {buttonName &&
            <Form.Item className='auth-form__fixed-submit'>
              {backButton &&
                <Button type='link' href={`/${backButtonRedirection}`}>
                  Back
                </Button>
              }
              <Button
                // href='/forgot-pin/confirm-new-pin' 
                onClick={() => handleSubmit()}
                htmlType='submit'
                type='primary'
                className='ant-btn-primary--alt'
                disabled={pin?.length !== 4}
                loading={loading}
              >
                {buttonName}
              </Button>
            </Form.Item>
          }
        </Form>
      </AuthForm >
    </>
  );
};

export default PinPage;
